import React, { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import jMoment from 'moment-jalaali';
import { useNavigate, useParams } from 'react-router-dom';
import { PageContainer, PriceLabel } from 'components';
import { useQuery } from 'hooks';
import { constBreadCrumbsTitle } from 'utility';
import { GUARANTOR_CODE_OPTIONS } from '../constants/Options';
import LoanServices from '../services/LoanServices';
import { useStyles } from './style';
import useCustomHook from '../hooks';
import { useCurrencyUnit } from 'hooks';

const Constraints = (props) => {
  // -- STATE --//
  const { loan, setLoan, loading, setLoading } = useCustomHook();
  const { id } = useParams();
  const currencyText = useCurrencyUnit(false);

  // --HOOKS--//
  const classes = useStyles();

  const navigate = useNavigate();
  const query = useQuery();

  const isUser = query.get('isUser');
  useEffect(() => {
    const getLoanDetail = async (id) => {
      try {
        setLoading(true);
        const res = await LoanServices[isUser === 'true' ? 'getLoanDetails' : 'getUserLoanDetails'](
          id,
        );
        setLoan(res.result);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      getLoanDetail(id);
    }
  }, [id, isUser]);

  return (
    <PageContainer
      title="جزییات تسهیلات"
      onBackClick={() => navigate(-1)}
      breadcrumbs={constBreadCrumbsTitle.LOAN_DETAILS}
      className={classes.root}
      loading={loading}
    >
      <Grid container direction="row" alignItems="center">
        {loan && (
          <Grid item xs={12}>
            <Grid container className={classes.info}>
              <Grid item xs={12}>
                <Typography component="h2" style={{ fontSize: '16px' }}>
                  اطلاعات قرارداد
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>نام قرارداد</Typography>
                <Typography className={classes.detailValue}>
                  {loan?.loan?.contract?.name ?? '-'}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>ضامن</Typography>
                <Typography className={classes.detailValue} style={{ fontFamily: 'Vazir' }}>
                  {GUARANTOR_CODE_OPTIONS.find((o) => o.value === loan?.loan?.contract?.guarantor)
                    ?.label ?? '-'}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>تاریخ ایجاد</Typography>
                <Typography className={classes.detailValue}>
                  {jMoment(loan?.loan?.contract?.creationDate).format('HH:mm - jYYYY/jMM/jD') ??
                    '-'}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>تاریخ پایان</Typography>
                <Typography className={classes.detailValue}>
                  {jMoment(loan?.loan?.contract?.endDate).format('HH:mm - jYYYY/jMM/jD') ?? '-'}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>وضعیت</Typography>
                <Typography className={classes.detailValue}>
                  {loan?.loan?.contract?.active ? 'فعال' : 'غیرفعال'}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography component="h2" style={{ fontSize: '16px', marginTop: '2em' }}>
                  اطلاعات طرح بازپرداخت
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>نام طرح</Typography>
                <Typography className={classes.detailValue}>
                  {loan?.loan?.plan?.name ?? '-'}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>نرخ سود</Typography>
                <Typography className={classes.detailValue}>
                  {loan?.loan?.plan?.interestRate || 0} %
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>تاریخ ایجاد</Typography>
                <Typography className={classes.detailValue}>
                  {jMoment(loan?.loan?.plan?.creationDate).format('HH:mm - jYYYY/jMM/jD') ?? '-'}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                <Typography className={classes.detailTitle}>وضعیت</Typography>
                <Typography className={classes.detailValue}>
                  {loan?.loan?.plan?.acticve ? 'فعال' : 'غیرفعال'}
                </Typography>
              </Grid>
              {isUser === 'true' && (
                <>
                  <Grid item xs={12}>
                    <Typography component="h2" style={{ fontSize: '16px', marginTop: '2em' }}>
                      اطلاعات اعتبار کاربر
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                    <Typography className={classes.detailTitle}>اعتبار کاربر</Typography>
                    <Typography className={classes.detailValue}>
                      <PriceLabel amount={loan.amount} />
                      <PriceLabel amount={loan?.credit ? loan?.credit?.amount : 0} />
                      <span className={classes.priceLabel}>{currencyText}</span>
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                    <Typography className={classes.detailTitle}>میزان مصرف شده</Typography>
                    <Typography className={classes.detailValue}>
                      <PriceLabel
                        amount={
                          loan?.credit ? loan?.credit?.amount - loan?.credit?.remainingAmount : 0
                        }
                      />
                      <span className={classes.priceLabel}>{currencyText}</span>
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                    <Typography className={classes.detailTitle}>میزان باقی مانده</Typography>
                    <Typography className={classes.detailValue}>
                      <PriceLabel amount={loan?.credit ? loan?.credit?.remainingAmount : 0} />
                      <span className={classes.priceLabel}>{currencyText}</span>
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </PageContainer>
  );
};

export default Constraints;
